import { Box, makeStyles } from '@material-ui/core'
import React from 'react'
import { MainContainer } from '../../atoms'

const useStyles = makeStyles((theme) => ({
    wrapper: {
        margin: '3% 0%',
        padding: '0 5%',
        fontSize: '18px',
        fontFamily: theme.typography.fontFamily,
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            padding: '0 8%',
        },
    },
    marqueeOuter: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        width: '100%',
    },
    marqueeTrack: {
        display: 'inline-flex',
        alignItems: 'center',
        animation: '$scroll 15s linear infinite',
        '&:hover': {
            animationPlayState: 'paused',
        },
    },
    marqueeItem: {
        display: 'inline-flex',
        alignItems: 'center',
        paddingRight: '6rem', // gap before it repeats
        paddingLeft:'6rem',
        flexShrink: 0,
    },
    '@keyframes scroll': {
        '0%': {
            transform: 'translateX(0%)',
        },
        '100%': {
            transform: 'translateX(-50%)',
        },
    },
    link: {
        color: '#182AC3',
        textDecoration: 'underline',
        fontWeight: 600,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    description: {
        color: '#d93025',
        fontFamily: 'inherit',
        whiteSpace: 'nowrap',
    },
}))

export function EndOfSupportNotice({ linkText = 'End of Support', description, href }) {
    const classes = useStyles()

    const content = (
        <span className={classes.marqueeItem}>
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
            >
                {linkText}
            </a>
            <span className={classes.description}> {description}</span>
        </span>
    )

    return (
        <MainContainer>
            <Box className={classes.wrapper}>
                <div className={classes.marqueeOuter}>
                    <div className={classes.marqueeTrack}>
                        {content}
                        {content}
                        {content}
                    </div>
                </div>
            </Box>
        </MainContainer>
    )
}